<template>
  <div class="PHD tier-selector">
    <div class="container container-fluid">
        <h1 class="page-heading">Institutional Tier Component</h1>
    </div>
    <!-- CONTENT -->
   
    <!-- CONTAINER -->
    <div class="container container-fluid institutional-tier__wrapper">
        <!-- TIER SELECTOR - - - - - - - - - -  -->
        <div class="col-sm-12">
            
            <div class="row l-tier-selector">
                <div class="col-12 d-block">
                    <!--  -->
                    <div class="l-promo l-promo--image institutional-tier--image">
                        <div class="l-promo__col">
                            <div class="c-image-promo c-image-promo--full institutional-tier--image-promo">
                                <div class="c-image-promo__media h-placeholder-image">
                                    <img src="assets/images/placeholder.gif" v-lazy-img="'//placehold.it/300x600/333333/666666?text=FPO'" />
                                </div>
                            </div>
                        </div>

                        <div class="l-promo__col d-none d-md-block">
                            <div class="c-image-promo c-image-promo--full institutional-tier--image-promo">
                                <div class="c-image-promo__media h-placeholder-image">
                                    <img src="assets/images/placeholder.gif" v-lazy-img="'//placehold.it/300x600/333333/666666?text=FPO'" />
                                </div>
                            </div>
                        </div>

                        <div class="l-promo__col d-none d-md-block">
                            <div class="c-image-promo c-image-promo--full institutional-tier--image-promo">
                                <div class="c-image-promo__media h-placeholder-image">
                                    <img src="assets/images/placeholder.gif" v-lazy-img="'//placehold.it/300x600/333333/666666?text=FPO'" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                </div>

                <div class="col-3 c-tier-selector__tabs institutional-tier__tabs">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link" @click.prevent="setActive('premier')" :class="{ active: isActive('premier') }" id="v-pills-premier-tab" data-toggle="pill" href="#v-pills-premier" role="tab" aria-controls="v-pills-premier" :aria-selected="[isActive('premier') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading institutional-tier__heading">Tier 1</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link" @click.prevent="setActive('professional')" :class="{ active: isActive('professional') }" id="v-pills-professional-tab" data-toggle="pill" href="#v-pills-professional" role="tab" aria-controls="v-pills-professional" :aria-selected="[isActive('professional') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading institutional-tier__heading">Tier 2</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link" @click.prevent="setActive('limited')" :class="{ active: isActive('limited') }" id="v-pills-limited-tab" data-toggle="pill" href="#v-pills-limited" role="tab" aria-controls="v-pills-limited" :aria-selected="[isActive('limited') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading institutional-tier__heading">Tier 3</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link" @click.prevent="setActive('early')" :class="{ active: isActive('early') }" id="v-pills-early-tab" data-toggle="pill" href="#v-pills-early" role="tab" aria-controls="v-pills-early" :aria-selected="[isActive('early') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading institutional-tier__heading">Tier 4</div>
                                </div>
                            </div>
                        </a>

                        <!-- Group Pricing -->
                        <a href="#">
                            <div class="c-tier-promo-card">
                                <div class="card__img">

                                </div>
                                <div class="card__content">

                                </div>
                            </div>
                        </a>
                        <!-- End Group Pricing -->


                    </div>
                </div>
                <!-- / --------------------------------------------------------------------------------------------------------------------------------- / -->
                <div class="col-9 c-tier-selector__tab-panels">
                    <div class="tab-content" id="v-pills-tabContent">
                        <!-- / -->
                        
                            <div class="tab-pane " :class="{ 'active show': isActive('premier') }" id="v-pills-premier" role="tabpanel" aria-labelledby="v-pills-premier-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-premier'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('premier')" :class="{ active: isActive('premier') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Tier 1</div>
                                           
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-premier" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4">Premier</h2>
                                        <div class="h3">Council Affiliations</div>
                                        <ul >
                                            <li>Affiliate with up to two of our&nbsp;<strong><a href="/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp" target="_blank">16 Scientific Councils</a></strong>.</li>
                                            <li>(Optional) Affiliate with a third council for an additional $65/year.</li>
                                        </ul>
                                        <div class="h3">AHA Scientific Journals</div>
                                        <ul >
                                            <li>Access to all&nbsp;<strong>11 online</strong>&nbsp;<strong><a href="https://www.ahajournals.org/" target="_blank">AHA scientific journals</a></strong>&nbsp;(full text)</li>
                                            <li>Yearly print subscriptions only $225 per journal (<em>ATVB, Circulation, Circulation Research, Hypertension, Stroke</em>)</li>
                                            <li>Access to CME credits through the&nbsp;<strong><a href="https://cme.ahajournals.org/s/catalog" target="_blank">AHA Journals CME</a>&nbsp;</strong>program</li>
                                            <li><strong><a href="/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp" target="_blank">Discounted article publication charges</a></strong>&nbsp;for accepted articles in&nbsp;<strong><a href="https://www.ahajournals.org/journal/jaha" target="_blank"><em>JAHA</em></a></strong>&nbsp;(the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code</li>
                                        </ul>
                                        <div class="h3">Conferences and Education</div>
                                        <ul >
                                            <li>Save on AHA/ASA&nbsp;<strong><a href="/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp" target="_blank">Scientific Conferences</a>&nbsp;</strong>registration</li>
                                            <li>Savings on Science OnDemand® products,</li>
                                            <li>Priority Registration and Housing for Scientific Sessions and the International Stroke Conference</li>
                                            <li>Complimentary and/or discounted courses through the&nbsp;<strong><a href="https://learn.heart.org/" target="_blank">Lifelong Learning Center</a></strong></li>
                                        </ul>
                                        <div class="h3">Opportunities</div>
                                        <ul >
                                            <li>Funding opportunities for members only</li>
                                            <li>Become a&nbsp;<strong><a href="/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp" target="_blank">Fellow of the American Heart Association (FAHA)</a></strong></li>
                                            <li>Leadership Opportunities</li>
                                            <li>Networking with like-minded professionals</li>
                                            <li>Get involved in the AHA mission and to mentor others</li>
                                            <li>Access to Science News</li>
                                            <li>Eligible for AHA council grants and awards</li>
                                            <li>Quarterly AHA Connections Newsletter</li>
                                            <li>Inclusion/ access to the online AHA/ASA Professional Membership Directory</li>
                                            <li>Achieve Golden and Silver Heart Membership</li>
                                            <li>Be a part of the Emeritus Membership program</li>
                                        </ul>

                                        <!-- Sign Up -->
                                        <div class="btn-wrapper">
                                            <a href="#" class="btn btn-primary btn-round btn-block btn--signup">Sign Up</a>
                                        </div>
                                        <!-- End -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane" :class="{ 'show active': isActive('professional') }" id="v-pills-professional" role="tabpanel" aria-labelledby="v-pills-professional-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-professional'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('professional')" :class="{ active: isActive('professional') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Tier 2</div>
                                           
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-professional" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4">Professional</h2>
                                        <div class="h3">Council Affiliations</div>
                                        <ul >
                                            <li>2 Affiliate with up to two of our&nbsp;<strong><a href="/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp" target="_blank">16 Scientific Councils</a></strong>.</li>
                                            <li>(Optional) Affiliate with a third council for an additional $65/year.</li>
                                        </ul>
                                        <div class="h3">AHA Scientific Journals</div>
                                        <ul >
                                            <li>Access to all&nbsp;<strong>11 online</strong>&nbsp;<strong><a href="https://www.ahajournals.org/" target="_blank">AHA scientific journals</a></strong>&nbsp;(full text)</li>
                                            <li>Yearly print subscriptions only $225 per journal (<em>ATVB, Circulation, Circulation Research, Hypertension, Stroke</em>)</li>
                                            <li>Access to CME credits through the&nbsp;<strong><a href="https://cme.ahajournals.org/s/catalog" target="_blank">AHA Journals CME</a>&nbsp;</strong>program</li>
                                            <li><strong><a href="/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp" target="_blank">Discounted article publication charges</a></strong>&nbsp;for accepted articles in&nbsp;<strong><a href="https://www.ahajournals.org/journal/jaha" target="_blank"><em>JAHA</em></a></strong>&nbsp;(the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code</li>
                                        </ul>
                                        <div class="h3">Conferences and Education</div>
                                        <ul >
                                            <li>Save on AHA/ASA&nbsp;<strong><a href="/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp" target="_blank">Scientific Conferences</a>&nbsp;</strong>registration</li>
                                            <li>Savings on Science OnDemand® products,</li>
                                            <li>Priority Registration and Housing for Scientific Sessions and the International Stroke Conference</li>
                                            <li>Complimentary and/or discounted courses through the&nbsp;<strong><a href="https://learn.heart.org/" target="_blank">Lifelong Learning Center</a></strong></li>
                                        </ul>
                                        <div class="h3">Opportunities</div>
                                        <ul >
                                            <li>Funding opportunities for members only</li>
                                            <li>Become a&nbsp;<strong><a href="/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp" target="_blank">Fellow of the American Heart Association (FAHA)</a></strong></li>
                                            <li>Leadership Opportunities</li>
                                            <li>Networking with like-minded professionals</li>
                                            <li>Get involved in the AHA mission and to mentor others</li>
                                            <li>Access to Science News</li>
                                            <li>Eligible for AHA council grants and awards</li>
                                            <li>Quarterly AHA Connections Newsletter</li>
                                            <li>Inclusion/ access to the online AHA/ASA Professional Membership Directory</li>
                                            <li>Achieve Golden and Silver Heart Membership</li>
                                            <li>Be a part of the Emeritus Membership program</li>
                                        </ul>

                                        <!-- Sign Up -->
                                        <div class="btn-wrapper">
                                            <a href="#" class="btn btn-primary btn-round btn-block btn--signup">Sign Up</a>
                                        </div>
                                        
                                        <!-- End -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane" :class="{ 'show active': isActive('limited') }" id="v-pills-professional" role="tabpanel" aria-labelledby="v-pills-limited-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-limited'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('limited')" :class="{ active: isActive('limited') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Tier 3</div>
                                         
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-limited" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4">Limited</h2>
                                        <div class="h3">Council Afiliations</div>
                                        <ul >
                                            <li>3 Affiliate with up to two of our&nbsp;<strong><a href="/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp" target="_blank">16 Scientific Councils</a></strong>.</li>
                                            <li>(Optional) Affiliate with a third council for an additional $65/year.</li>
                                        </ul>
                                        <div class="h3">AHA Scientific Journals</div>
                                        <ul >
                                            <li>Access to all&nbsp;<strong>11 online</strong>&nbsp;<strong><a href="https://www.ahajournals.org/" target="_blank">AHA scientific journals</a></strong>&nbsp;(full text)</li>
                                            <li>Yearly print subscriptions only $225 per journal (<em>ATVB, Circulation, Circulation Research, Hypertension, Stroke</em>)</li>
                                            <li>Access to CME credits through the&nbsp;<strong><a href="https://cme.ahajournals.org/s/catalog" target="_blank">AHA Journals CME</a>&nbsp;</strong>program</li>
                                            <li><strong><a href="/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp" target="_blank">Discounted article publication charges</a></strong>&nbsp;for accepted articles in&nbsp;<strong><a href="https://www.ahajournals.org/journal/jaha" target="_blank"><em>JAHA</em></a></strong>&nbsp;(the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code</li>
                                        </ul>
                                        <div class="h3">Conferences and Education</div>
                                        <ul >
                                            <li>Save on AHA/ASA&nbsp;<strong><a href="/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp" target="_blank">Scientific Conferences</a>&nbsp;</strong>registration</li>
                                            <li>Savings on Science OnDemand® products,</li>
                                            <li>Priority Registration and Housing for Scientific Sessions and the International Stroke Conference</li>
                                            <li>Complimentary and/or discounted courses through the&nbsp;<strong><a href="https://learn.heart.org/" target="_blank">Lifelong Learning Center</a></strong></li>
                                        </ul>
                                        <div class="h3">Opportunities</div>
                                        <ul >
                                            <li>Funding opportunities for members only</li>
                                            <li>Become a&nbsp;<strong><a href="/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp" target="_blank">Fellow of the American Heart Association (FAHA)</a></strong></li>
                                            <li>Leadership Opportunities</li>
                                            <li>Networking with like-minded professionals</li>
                                            <li>Get involved in the AHA mission and to mentor others</li>
                                            <li>Access to Science News</li>
                                            <li>Eligible for AHA council grants and awards</li>
                                            <li>Quarterly AHA Connections Newsletter</li>
                                            <li>Inclusion/ access to the online AHA/ASA Professional Membership Directory</li>
                                            <li>Achieve Golden and Silver Heart Membership</li>
                                            <li>Be a part of the Emeritus Membership program</li>
                                        </ul>

                                        <!-- Sign Up -->
                                        <div class="btn-wrapper">
                                            <a href="#" @click.prevent="" v-b-modal="'limited-membership-modal'" class="btn btn-primary btn-round btn-block btn--signup">Sign Up</a>
                                        </div>
                                        
                                        <!-- End -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                            
                        
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane" :class="{ 'show active': isActive('early') }" id="v-pills-professional" role="tabpanel" aria-labelledby="v-pills-early-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-early'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('early')" :class="{ active: isActive('early') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Tier 4</div>
                                      
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-early" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4">Early Career</h2>
                                        <div class="h3">Council Affiliations</div>
                                        <ul >
                                            <li>4 Affiliate with up to two of our&nbsp;<strong><a href="/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp" target="_blank">16 Scientific Councils</a></strong>.</li>
                                            <li>(Optional) Affiliate with a third council for an additional $65/year.</li>
                                        </ul>
                                        <div class="h3">AHA Scientific Journals</div>
                                        <ul >
                                            <li>Access to all&nbsp;<strong>11 online</strong>&nbsp;<strong><a href="https://www.ahajournals.org/" target="_blank">AHA scientific journals</a></strong>&nbsp;(full text)</li>
                                            <li>Yearly print subscriptions only $225 per journal (<em>ATVB, Circulation, Circulation Research, Hypertension, Stroke</em>)</li>
                                            <li>Access to CME credits through the&nbsp;<strong><a href="https://cme.ahajournals.org/s/catalog" target="_blank">AHA Journals CME</a>&nbsp;</strong>program</li>
                                            <li><strong><a href="/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp" target="_blank">Discounted article publication charges</a></strong>&nbsp;for accepted articles in&nbsp;<strong><a href="https://www.ahajournals.org/journal/jaha" target="_blank"><em>JAHA</em></a></strong>&nbsp;(the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code</li>
                                        </ul>
                                        <div class="h3">Opportunities</div>
                                        <ul >
                                            <li>Funding opportunities for members only</li>
                                            <li>Become a&nbsp;<strong><a href="/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp" target="_blank">Fellow of the American Heart Association (FAHA)</a></strong></li>
                                            <li>Leadership Opportunities</li>
                                            <li>Networking with like-minded professionals</li>
                                            <li>Get involved in the AHA mission and to mentor others</li>
                                            <li>Access to Science News</li>
                                            <li>Eligible for AHA council grants and awards</li>
                                            <li>Quarterly AHA Connections Newsletter</li>
                                            <li>Inclusion/ access to the online AHA/ASA Professional Membership Directory</li>
                                            <li>Achieve Golden and Silver Heart Membership</li>
                                            <li>Be a part of the Emeritus Membership program</li>
                                        </ul>

                                        <!-- Sign Up -->
                                        <div class="btn-wrapper">
                                            <a href="#" class="btn btn-primary btn-round btn-block btn--signup">Sign Up</a>
                                        </div>
                                        
                                        <!-- End -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        
                        
                        <!-- / -->

                    </div>
                </div>
            </div>
        </div>
        <!-- END TIER SELECTOR - - - - - - - -  -->

        <br><br>
        
        <!-- MODAL - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <aha-modal id="table-comparison-modal" hide-footer centered class="table-comparison__modal">
        <!-- COMPARISON CHART -->
        <div class="row">
            <div class="col">
                <h2 class="text-center">Pick a Membership that's right for you</h2>
                <br>
                <p class="text-center text-muted">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.
                </p>
                <br>
                <!-- DESKTOP  -->
                <!-- TABLE -->
                <div class="l-comparison--desktop">
                    <table class="table table-hover table-comparison">
                        <thead>
                            <tr>
                            <th scope="col" class="text-center">&nbsp;</th>
                            <th scope="col" class="text-center">Premier</th>
                            <th scope="col" class="text-center">Professional</th>
                            <th scope="col" class="text-center">Limited</th>
                            <th scope="col" class="text-center">Signature</th>
                            </tr>
                        </thead>
                        <tbody>
                                
                            <tr>
                                <th scope="row">Journals</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                            </tr>
                            <tr>
                                <th scope="row">Council Affiliations</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                            </tr>
                            <tr>
                                <th scope="row">Discount</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                            </tr>
                            <tr>
                                <th scope="row">FAHA</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                            </tr>
                            <tr>
                                <th scope="row">Funding opportunities <em>members only</em></th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                            </tr>
                            <tr>
                                <th scope="row">Leadership opportunities</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot">•</td>
                            </tr>
                            <tr>
                                <th scope="row">Network with like-minded professionals</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot"><span aria-label="check">•</span></td>
                            </tr>
                            <tr>
                                <th scope="row">Get involved in the AHA mission and mentor others</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                            </tr>
                            <tr>
                                <th scope="row">Access to Science News</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                            </tr>
                            <tr>
                                <th scope="row">Eligible for AHA council grants and awards</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                            </tr>
                            <tr>
                                <th scope="row">Quarterly AHA Connections Newsleter</th>
                                <td class="text-center dot dot--active"><span aria-label="check">•</span></td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                                <td class="text-center dot ">•</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- END TABLE -->
                <!-- MOBILE - COLLAPSE -->
                <div class="l-comparison--mobile">
                    <!-- / -->
                    <div class="l-comparison__wrapper">
                    <b-button v-b-toggle.collapse-tier-premier class="btn--select btn-block text-left">Premier</b-button>
                    <b-collapse id="collapse-tier-premier" class="mt-2">
                        <ul class="list-unstyled">
                            <li>Journals</li>
                            <li>Councils Affiliations</li>
                            <li>Discount</li>
                            <li>FAHA</li>
                            <li>Funding opportunities members only</li>
                            <li>Leadership opportunities</li>
                            <li>Network with like-minded professionals</li>
                            <li>Get involved in the AHA mission and mentor others</li>
                            <li>Access to Science News</li>
                            <li>Eligible for AHA council grants and awards</li>
                            <li>Quarterly AHA Connections Newsleter</li>
                        </ul>
                    </b-collapse>
                    </div>
                    <!-- / -->
                    <!-- / -->
                    <div class="l-comparison__wrapper">
                    <b-button v-b-toggle.collapse-tier-professional class="btn--select btn-block text-left">Professional</b-button>
                    <b-collapse id="collapse-tier-professional" class="mt-2">
                        <ul class="list-unstyled">
                            <li>Journals</li>
                            <li>Councils Affiliations</li>
                            <li>Discount</li>
                            <li>FAHA</li>
                            <li>Funding opportunities members only</li>
                            <li>Leadership opportunities</li>
                            <li>Network with like-minded professionals</li>
                            <li>Get involved in the AHA mission and mentor others</li>
                        </ul>
                    </b-collapse>
                    </div>
                    <!-- / -->
                    <!-- / -->
                    <div class="l-comparison__wrapper">
                    <b-button v-b-toggle.collapse-tier-limited class="btn--select btn-block text-left">Limited</b-button>
                    <b-collapse id="collapse-tier-limited" class="mt-2">
                        <ul class="list-unstyled">
                            <li>Journals</li>
                            <li>Councils Affiliations</li>
                            <li>Discount</li>
                            <li>FAHA</li>
                        </ul>
                    </b-collapse>
                    </div>
                    <!-- / -->
                    <!-- / -->
                    <div class="l-comparison__wrapper">
                    <b-button v-b-toggle.collapse-tier-signature class="btn--select btn-block text-left">Signature</b-button>
                    <b-collapse id="collapse-tier-signature" class="mt-2">
                        <ul class="list-unstyled">
                            <li>Journals</li>
                            <li>Councils Affiliations</li>
                            <li>Discount</li>
                            <li>FAHA</li>
                        </ul>
                    </b-collapse>
                    </div>
                    <!-- / -->
                </div>

            </div>
        </div>
        <!-- END COMPARISON CHART -->
        </aha-modal>
        <!-- END MODAL - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

         <!-- MODAL LIMIED TIER - - - - - - - - - - - - - - - - - - - - -- - - - - -->
        <aha-modal id="limited-membership-modal" hide-footer centered class="limited-membership__modal">
            <h2 class="text-center">Limited Membership</h2>

            <!-- <b-btn-close @click="$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)">×</b-btn-close> -->

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio commodi vero similique amet eos, voluptas dolores rerum modi quasi nesciunt placeat odio incidunt sint animi eum earum vel consectetur soluta!</p>
            <!-- Buttons -->
            <div class="d-flex justify-content-center">
                <button class="btn btn-link-plain" @click="$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)">Go Back</button>
                <button class="btn btn-primary" @click="$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)">Continue</button>
            </div>

            
        </aha-modal>
        <!-- END MODAL - - - -- - - - - - - - - - - - - - - - - -- - - -- - -- -  -->



    </div>
    <!-- END CONTAINER -->
    


    <!-- end -->
  </div>
</template>

<script>
import idMixin from '@/mixins/aha-id';
export default {
    name: 'selector',
    mixins: [ idMixin ],
    data() {
        return {
            activeItem: 'premier',
            tierId: null,
            mobile: window.innerWidth <= 700

        }
    },
    created() {
       if(this.mobile) {
           this.activeItem = ' ';
       }
    },
    methods: {
        isActive (menuItem) {
            return this.activeItem === menuItem
        },
        setActive (menuItem) {
            this.activeItem = menuItem;
            if(this.activeItem === 'limited') {
                console.log('limited')
            }
        },
        onHidden() {
            console.log("closed");
            this.activeItem = ''
        }
    },
    mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId)
    }
}
</script>



// WEBPACK FOOTER //
// demo/components/phd/institutional-tier.vue